import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

export type HostPlatform = 'wpp' | 'hub'

interface HostPlatformContextValue {
  platform: HostPlatform
  isWpp: boolean
  isHub: boolean
}

const HostPlatformContext = createContext<HostPlatformContextValue>({ platform: 'hub', isWpp: false, isHub: true })

export const HostPlatformProvider = ({ platform, children }: PropsWithChildren<{ platform: HostPlatform }>) => {
  const value = useMemo(() => ({ platform, isWpp: platform === 'wpp', isHub: platform === 'hub' }), [platform])

  return <HostPlatformContext.Provider value={value}>{children}</HostPlatformContext.Provider>
}

export const useHostPlatform = () => useContext(HostPlatformContext)
